import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import InplayIcon from "./../../assets/images/icons/InPlay.png";
import CricketIcon from "./../../assets/images/icons/Cricket.png";
import SoccerIcon from "./../../assets/images/icons/football.png";
import TennisIcon from "./../../assets/images/icons/Tennis.png";
import AviatorIcon from "./../../assets/images/icons/Aviator.png";
import EvolutionIcon from "./../../assets/images/icons/Evolution.png";
import EzugiIcon from "./../../assets/images/icons/Ezugi.png";
import XPGNew from "./../../assets/images/icons/xpgicon.png";
import SupernowaIcon from "./../../assets/images/icons/supernowaicon.png";
import VivoNew from "./../../assets/images/icons/Vivo.png";
import QtechNew from "./../../assets/images/icons/Qtech.png";
import Sportsbook from "./../../assets/images/icons/Sportsbook.png";
import SlotsIconNew from "./../../assets/images/icons/Slots.png";
import Kingmaker from "./../../assets/images/icons/Kingmaker.png";
import CasinoIcon from "./../../assets/images/icons/Casino.png";
import SportsIcon from "./../../assets/images/icons/Sports.png";
import Mines from "./../../assets/images/icons/Mines.png";
import HotGames from "./../../assets/images/icons/download.png";

import PromotionIcon from "./../../assets/images/icons/Promotion.png";
import BonusIcon from "./../../assets/images/icons/Bonus.png";
import TermsnConIcon from "./../../assets/images/icons/Terms&Condition.png";
import ResponsibleGamingIcon from "./../../assets/images/icons/ResponsibleGambling.png";
import FairplayIcon from "./../../assets/images/icons/Fairplay.png";
import PrivacyPolicyIcon from "./../../assets/images/icons/PrivacyPolicy.png";
import AboutusIcon from "./../../assets/images/icons/Terms.png";
import ContactusIcon from "./../../assets/images/icons/Contact.png";
import GamesRulesIcon from "./../../assets/images/icons/GameRule.png";
import AffiliatesIcon from "./../../assets/images/icons/affiliate.png";

import { Accordion } from "react-bootstrap";

const MENU_ITEMS = [
  {
    id: 12,
    name: "Mines",
    redirectUrl: "/casino/spribe/mines",
    className: "",
    icon: Mines,
    hotimg: HotGames,
  },
  {
    id: 0,
    name: "Casino",
    redirectUrl: "/casino",
    className: "",
    icon: CasinoIcon,
  },
  {
    id: 1,
    name: "Sportsbook",
    redirectUrl: "/sportsbook2",
    className: "",
    icon: Sportsbook,
  },
  {
    id: 2,
    name: "Slots",
    redirectUrl: "/slots",
    className: "",
    icon: SlotsIconNew,
  },
  {
    id: 3,
    name: "Kingmaker",
    redirectUrl: "/kingmaker",
    className: "",
    icon: Kingmaker,
  },
  {
    id: 4,
    name: "Supernowa",
    redirectUrl: "/casino/supernowa",
    className: "",
    icon: SupernowaIcon,
  },
  {
    id: 5,
    name: "Aviator",
    redirectUrl: "/casino/spribe-aviator",
    className: "",
    icon: AviatorIcon,
  },
  {
    id: 6,
    name: "Evolution",
    redirectUrl: "/casino/evolution",
    className: "",
    icon: EvolutionIcon,
  },
  {
    id: 7,
    name: "Ezugi",
    redirectUrl: "/casino/ezugi",
    className: "",
    icon: EzugiIcon,
  },
  {
    id: 8,
    name: "XPG",
    redirectUrl: "/casino/xpg",
    className: "",
    icon: XPGNew,
  },
  {
    id: 9,
    name: "Vivo",
    redirectUrl: "/casino/vivo",
    className: "",
    icon: VivoNew,
  },
  {
    id: 10,
    name: "Qtech",
    redirectUrl: "/casino/qtech",
    className: "",
    icon: QtechNew,
  },
  {
    id: 11,
    name: "Offers",
    redirectUrl: "/promotion",
    className: "",
    icon: BonusIcon,
  },
];
const LeftBarSports = () => {
  const navigate = useNavigate();
  const htmlElement = document.documentElement;
  const location = useLocation();
  const [activeHoverElement, setActiveHoverElement] = useState(null);

  useEffect(() => {
    htmlElement.style.overflow = "auto";
    document.body.classList.remove("leftbat-opened");
  }, [location]);

  const { isAuth } = useSelector((state) => state.auth);

  return (
    <>
      <div className="leftbarSec">
        <ul>
          <li className="games_link">
            <Accordion className="sidebaraccordian">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div
                    onClick={() => {
                      // if (isAuth) {
                      //   navigate("/spmsports/cricket", {
                      //     state: { selectedTab: "1" },
                      //   });
                      // } else {
                      //   navigate("/spmsports/cricket", {
                      //     state: { selectedTab: "1" },
                      //   });
                      // }
                    }}
                  >
                    <div className="img-box">
                      <img
                        loading="lazy"
                        src={SportsIcon}
                        alt="Inplay Icon"
                        width={22}
                        height={22}
                      />
                    </div>
                    <span>Sports</span>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <ul>
                    <li>
                      <a href="/spmsports/live">
                        <img
                          loading="lazy"
                          src={InplayIcon}
                          alt="Inplay Icon"
                          width={22}
                          height={22}
                        />
                        <span>In-play</span>
                      </a>
                    </li>
                    <li>
                      <a href="/spmsports/cricket">
                        <img
                          loading="lazy"
                          src={CricketIcon}
                          width={22}
                          height={22}
                        />
                        <span className="game-name">Cricket</span>
                      </a>
                    </li>
                    <li>
                      <a href="/spmsports/soccer">
                        <img
                          loading="lazy"
                          src={SoccerIcon}
                          width={22}
                          height={22}
                        />
                        <span className="game-name">Soccer</span>
                      </a>
                    </li>
                    <li>
                      <a href="/spmsports/tennis">
                        <img
                          loading="lazy"
                          src={TennisIcon}
                          width={22}
                          height={22}
                        />
                        <span className="game-name">Tennis</span>
                      </a>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            {/* <ul>
              <li className="mainOption">
                <div
                  onClick={() => {
                    navigate("/casino/spribe-mines");
                  }}
                  data-tooltip-id="my-tooltip-1"
                >
                  <div className="img-box">
                    <img loading="lazy"src={Mines} alt="Inplay Icon" />
                  </div>
                  <span>Mines!</span>
                </div>
              </li>
            </ul> */}
            {/* <h6>Quick Links</h6> */}

            <ul>
              {MENU_ITEMS.map((item, idx) => {
                return (
                  <li
                    key={idx}
                    onMouseEnter={() => {
                      setActiveHoverElement(item?.id);
                    }}
                    onMouseLeave={() => {
                      setActiveHoverElement(null);
                    }}
                    className={item?.id === activeHoverElement ? "active" : ""}
                  >
                    <div
                      onClick={() => {
                        navigate(item.redirectUrl);
                      }}
                    >
                      <div className="img-box">
                        <img
                          loading="lazy"
                          src={item?.icon}
                          alt="Inplay Icon"
                          width={22}
                          height={22}
                        />
                      </div>
                      <span>
                        {item.name}{" "}
                        <img
                          loading="lazy"
                          src={item?.hotimg}
                          alt="Inplay Icon"
                        />
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>
          </li>

          <li className="games_link">
            <ul className="d-md-none d-block">
              {/* <li>
                <div
                  onClick={() => {
                    navigate("/affiliates");
                  }}
                >
                  <div className="img-box">
                    <img loading="lazy"src={AffiliatesIcon} alt="Casino Icon" />
                  </div>
                  <span>Affiliate</span>
                </div>
              </li> */}
              <Accordion className="sidebaraccordian">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <div
                      onClick={() => {
                        if (isAuth) {
                          navigate("/spmsports/cricket", {
                            state: { selectedTab: "1" },
                          });
                        } else {
                          navigate("/spmsports/cricket", {
                            state: { selectedTab: "1" },
                          });
                        }
                      }}
                    >
                      <div className="img-box">
                        <img
                          loading="lazy"
                          src={AboutusIcon}
                          alt="Inplay Icon"
                          width={22}
                          height={22}
                        />
                      </div>
                      <span>Terms</span>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>
                        <a href="/contactus">
                          <img
                            loading="lazy"
                            src={ContactusIcon}
                            alt="Inplay Icon"
                            width={22}
                            height={22}
                          />

                          <span>Contact Us</span>
                        </a>
                      </li>
                      <li>
                        <a href="/privacypolicy">
                          <img
                            loading="lazy"
                            src={PrivacyPolicyIcon}
                            width={22}
                            height={22}
                          />
                          <span className="game-name">Privacy Policy</span>
                        </a>
                      </li>
                      <li>
                        <a href="/responsiblegame">
                          <img
                            loading="lazy"
                            src={ResponsibleGamingIcon}
                            width={22}
                            height={22}
                          />
                          <span className="game-name">Responsible Gaming</span>
                        </a>
                      </li>
                      <li>
                        <a href="/fairplay">
                          <img
                            loading="lazy"
                            src={FairplayIcon}
                            width={22}
                            height={22}
                          />
                          <span className="game-name">Fairplay</span>
                        </a>
                      </li>
                      <li>
                        <a href="/gamesrule">
                          <img
                            loading="lazy"
                            src={GamesRulesIcon}
                            width={22}
                            height={22}
                          />
                          <span className="game-name">Games Rules</span>
                        </a>
                      </li>
                      <li>
                        <a href="/terms">
                          <img
                            loading="lazy"
                            src={TermsnConIcon}
                            width={22}
                            height={22}
                          />
                          <span className="game-name">
                            Terms and Conditions
                          </span>
                        </a>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
};

export default LeftBarSports;
//
